import { http, httpV2 } from "@/api";

/**
 * @summary Solicita o resultado do diagnóstico para o conjunto de resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @returns {promise} Retorna status do diagnóstico.
 */
const GetResult = function(resultSetId)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/Looseness`);
};

/**
 * @summary Solicita os dados para construção do gráfico do resultado.
 * @param {number} resultSetId Id do conjunto de resultado.
 * @param {number} shaft Região do exio.
 * @returns {promise} Retorna os eixos do gráfico e frequências de interesse.
 */
const GetChart = function(resultSetId, shaft)
{
	return http.get(`/WindTurbinesDiagnostic/${resultSetId}/${shaft}/Looseness/Chart`);
};

/**
 * @summary Obtém as informações dos sinais de um diagnóstico.
 * @param {number} id - Id do diagnóstico.
 * @returns {promise} Promise da chamada da API.
 */
const GetDiagnosticSignals = function(id)
{
	return httpV2.get(`/RollingBearingLoosenessShafts/${id}/Signals`);
};

export default {
	GetResult,
	GetChart,
	GetDiagnosticSignals
};